import { Injectable } from '@angular/core';
import { ImageUtilsService } from './image-utils.service';

declare let THREE: any;
declare const window: any;

@Injectable()
export class HelperLinesService {
  constructor(private imageUtilsService: ImageUtilsService) {}

  lineMaterial = new THREE.LineBasicMaterial({
    color: 0x00ff00
  });

  lineType = {
    HORIZONTAL: 0,
    VERTICAL: 1
  };

  buildLine(type, material) {
    var geometry = new THREE.Geometry();
    geometry.vertices.push(
      new THREE.Vector3(-5000, 0, 0),
      new THREE.Vector3(0, 0, 0),
      new THREE.Vector3(5000, 0, 0)
    );

    var line = new THREE.Line(geometry, material);
    line.visible = false;
    line.name = type === this.lineType.HORIZONTAL ? 'horizontalHelperLine' : 'verticalHelperLine';
    line.rotation.y = type === this.lineType.VERTICAL ? Math.PI / 2 : 0;

    return line;
  }

  pointIntersection(point, points) {
    var pointX,
      pointY,
      i = 0,
      item;

    for (; i < points.length; i++) {
      item = points[i];
      if (Math.abs(item.x - point.x) < 12) pointY = item;
      else if (Math.abs(item.z - point.z) < 12) pointX = item;
    }

    return { horizontal: pointX, vertical: pointY };
  }

  horizontal = this.buildLine(this.lineType.HORIZONTAL, this.lineMaterial);
  vertical = this.buildLine(this.lineType.VERTICAL, this.lineMaterial);

  test(point, points) {
    var intersection = this.pointIntersection(point, points);
    var result = new THREE.Vector3();

    this.hideAll();

    if (intersection.horizontal && intersection.vertical) {
      this.horizontal.position.set(intersection.horizontal.x, 0, intersection.horizontal.z);
      this.vertical.position.set(intersection.vertical.x, 0, intersection.vertical.z);
      this.horizontal.visible = this.vertical.visible = true;
      result.set(intersection.vertical.x, 0, intersection.horizontal.z);
    } else if (intersection.horizontal) {
      this.horizontal.position.set(intersection.horizontal.x, 0, intersection.horizontal.z);
      this.horizontal.visible = true;
      result.set(point.x, 0, intersection.horizontal.z);
    } else if (intersection.vertical) {
      this.vertical.position.set(intersection.vertical.x, 0, intersection.vertical.z);
      this.vertical.visible = true;
      result.set(intersection.vertical.x, 0, point.z);
    } else result = null;

    return result;
  }

  getLines() {
    this.hideAll();
    return [this.horizontal, this.vertical];
  }

  hideAll() {
    this.vertical.visible = this.horizontal.visible = false;
  }

  generateTestSphereSprite(color: string, position: { x: number; y: number; z: number }) {
    const material = new THREE.MeshBasicMaterial({ color: color });
    const geometry = new THREE.SphereGeometry(5, 32, 32);
    const sphere = new THREE.Mesh(geometry, material);
    const v3 = new THREE.Vector3(position.x, position.y, position.z);
    sphere.position.copy(v3);
    sphere.name =
      'test123_' +
      Math.random()
        .toString(36)
        .substring(7);
    window.stg.add(sphere);
  }

  generateTestTextSpirte(text, position: { x: number; y: number; z: number }) {
    const sprite = this.imageUtilsService.textSprite(text, {
      fontsize: 24,
      borderColor: { r: 255, g: 0, b: 0, a: 1.0 },
      backgroundColor: { r: 255, g: 0, b: 0, a: 0.8 }
    });
    // console.log('text sprite', sprite);
    const v3 = new THREE.Vector3(position.x, position.y, position.z);
    sprite.position.copy(v3);
    sprite.scale.set(50, 40, 1);
    sprite.name =
      'test123_' +
      Math.random()
        .toString(36)
        .substring(7);
    window.stg.add(sprite);
  }

  removeTestMarkers() {
    if (window.stg) {
      window.stg.children.forEach(c => {
        if (c && c.name.includes('test123')) {
          // console.log('c.name', c.name);
          window.stg.remove(c);
        }
      });
    }
  }

  static buildTestLines = (
    position: { x: number; y: number; z: number },
    colorNumber = 0,
    name?
  ) => {
    const colors = {
      0: 0xff0000, // red
      1: 0x00ff00, // green
      2: 0x0000ff, // blue
      3: 0x000000, // black
      4: 0xff00ff, // pink
      5: 0x654321, // brown
      6: 0xbff00 // lime
    };
    const geometry = new THREE.Geometry();
    geometry.vertices.push(new THREE.Vector3(-5000, 0, 0));
    geometry.vertices.push(new THREE.Vector3(5000, 0, 0));
    geometry.vertices.push(new THREE.Vector3(0, -5000, 0));
    geometry.vertices.push(new THREE.Vector3(0, 5000, 0));
    geometry.vertices.push(new THREE.Vector3(0, 0, -5000));
    geometry.vertices.push(new THREE.Vector3(0, 0, 5000));

    const material = new THREE.LineBasicMaterial({ color: colors[colorNumber] });
    const lines = new THREE.LineSegments(geometry, material);
    const v3 = new THREE.Vector3(position.x, position.y, position.z);
    lines.position.copy(v3);
    lines.name = name
      ? name
      : 'test-lines-' +
        Math.random()
          .toString(36)
          .substring(7);
    lines.renderOrder = 10;
    window.scene.add(lines);
  };

  static buildOneTestLineAndUpdate = (
    position: { x: number; y: number; z: number },
    colorNumber = 0,
    uniqueLineName = JSON.stringify(position)
  ) => {
    const lines = window.scene.getObjectByName(uniqueLineName);
    if (lines) {
      lines.position.copy(position);
    } else {
      HelperLinesService.buildTestLines(position, colorNumber, uniqueLineName);
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/services/helper-lines.service.ts